import { defineAction } from '~/prix'
import entrepreneurAgentCheckAction from './agentCheckStream.action.json' assert { type: 'json' }
import {
  entrepreneurAgentCheckInput,
  entrepreneurAgentCheckOutput,
} from '../entrepreneurAgentCheck/entrepreneurAgentCheck.definition'

const entrepreneurAgentCheckDefinition = defineAction({
  ...entrepreneurAgentCheckAction,
  userActivityLogInput: 'omit' as const,
  operation: 'read' as const,
  input: entrepreneurAgentCheckInput,
  output: entrepreneurAgentCheckOutput,
})

export default entrepreneurAgentCheckDefinition
